<div class="flex flex-column border-bottom-1 surface-border p-6">
    <h3>Mes rendez-vous</h3>
</div>
<hr>
<div class="w-full flex row-gap-4 flex-column align-items-center surface-border py-4">
    <div class="flex flex-row flex-1 gap-4 mx-auto flex-wrap">
         <div *ngIf="isLoading()" class="flex flex-1 text-center justify-center">
            <p-progress-spinner strokeWidth="8" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px' }" />
        </div>
        <div *ngIf="!isLoading()" class="flex flex-col flex-1 h-[50rem] overflow-y-auto">
            <div *ngFor="let meeting of meetingsIncomming();">
                <app-meeting-item-card
                    [past]="false"
                    [meeting]="meeting"
                    class="w-full"
                    (updateMeetingEvent)="updateMeeting($event)"
                />
            </div>
            <div *ngIf="meetingsIncomming().length === 0" class="w-full flex justify-center font-light">
                <p class="text-center">Aucun rendez-vous à venir</p>
            </div>
            <i class="pt-4">Rendez-vous passés</i>
            <div *ngFor="let meeting of meetingsPast();">
                <app-meeting-item-card
                    [past]="true"
                    [meeting]="meeting"
                    class="w-full"
                />
            </div>
            <div *ngIf="meetingsPast().length === 0" class="w-full flex justify-center font-light">
                <p class="text-center">Aucun rendez-vous passé</p>
            </div>
        </div>
    </div>
</div>